<template>
  <svg
    width="41"
    height="42"
    viewBox="0 0 41 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="20.5" cy="21" r="20.5" fill="#F1F8FF" />
    <circle cx="20.5" cy="21.5" r="10.5" fill="url(#paint0_linear_2001_4391)" />
    <path
      d="M21.45 15.875V16.75C23.1909 16.75 24.6 18.1199 24.6 19.8125C24.6 20.4742 24.3834 21.0867 24.0178 21.5871C24.9066 22.1285 25.5 23.091 25.5 24.1875C25.5 25.8801 24.0909 27.25 22.35 27.25H21.45V28.125C21.45 28.609 21.0478 29 20.55 29C20.0522 29 19.65 28.609 19.65 28.125V27.25H17.6739C17.0257 27.25 16.5 26.7387 16.5 26.1098V17.7781C16.5 17.2099 16.9731 16.75 17.5567 16.75H19.65V15.875C19.65 15.3918 20.0522 15 20.55 15C21.0478 15 21.45 15.3918 21.45 15.875ZM19.65 18.5H18.3V21.125H19.65V18.5ZM22.8 19.8125C22.8 19.0879 22.1953 18.5 21.45 18.5V21.125C22.1953 21.125 22.8 20.5371 22.8 19.8125ZM19.65 22.875H18.3V25.5H19.65V22.875ZM22.35 25.5C23.0953 25.5 23.7 24.9121 23.7 24.1875C23.7 23.4629 23.0953 22.875 22.35 22.875H21.45V25.5H22.35Z"
      fill="#F1F8FF"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2001_4391"
        x1="20.5"
        y1="11"
        x2="20.5"
        y2="32"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#437BE8" />
        <stop offset="1" stop-color="#0F8DFB" />
      </linearGradient>
    </defs>
  </svg>
</template>
